import { useQuery } from "@tanstack/react-query";
import {
  mvpApiListPlanograms,
  PagedPlanogramSchema,
} from "@labeling-tools/api/atlas";

export type UseAtlasPlanogramsOptions = {
  /**
   * When true, list planograms even when `storeId` is missing (no `store_id` query param).
   * When false (default), the query only runs once `storeId` is set.
   */
  fetchWithoutStoreFilter?: boolean;
};

export function useAtlasPlanograms(
  storeId: string | null | undefined = null,
  options?: UseAtlasPlanogramsOptions,
) {
  const fetchWithoutStoreFilter = options?.fetchWithoutStoreFilter ?? false;
  const enabled = fetchWithoutStoreFilter || !!storeId;

  return useQuery({
    queryKey: ["fetch-atlas-planograms", storeId ?? "__unfiltered__"],
    queryFn: async () => {
      const response = await mvpApiListPlanograms({
        query: {
          ...(storeId ? { store_id: storeId } : {}),
          finalized: true,
        },
      });

      if (response.error) {
        throw new Error(`Failed to fetch product: ${response.error}`);
      }

      return response.data as PagedPlanogramSchema;
    },
    enabled,
  });
}
